/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        "key": "tips",
        "value": "一个页面只能有一个顶部导航，顶部导航会固定在页面顶部",
        "type": "tips"
    },
    {
        "name": "顶部导航",
        "type": "module-name"
    },
    {
        "key": "property_data",
        "name": "属性",
        "type": "custom",
        "content": [{
                "key": "background_color",
                "name": "背景颜色",
                "type": "color"
            },
            {
                "key": "unselected_font_color",
                "name": "未选中颜色",
                "type": "color",
            },
            {
                "key": "selected_font_color",
                "name": "选中颜色",
                "type": "color",
            }
        ],
    },
    {
        "key": "link_data",
        "name": "导航",
        "type": "top-nav"
    }
];

export default config;